import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { parseWeek } from "@/lib/hours";
import HoursWeekList from "@/components/yts/hours/HoursWeekList";

/** The week, folded shut until someone asks for it. */
export default function DetailHours({ listing, className = "" }) {
  const { t } = useLang();
  const [open, setOpen] = useState(false);
  const week = parseWeek(listing?.hours_json);
  const written = String(listing?.hours_text || "").trim();
  if (!week && !written) return null;

  return (
    <section id="hours" className={"scroll-mt-28 " + className}>
      <button
        type="button"
        onClick={() => week && setOpen((value) => !value)}
        aria-expanded={week ? open : undefined}
        className="flex w-full items-center justify-between gap-3 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#171717] dark:focus-visible:ring-white"
      >
        <span className="text-[16px] font-extrabold tracking-[-0.01em] text-[#171717] dark:text-[#f2efe9]">
          {t("detail.hours")}
        </span>
        {week && <ChevronDown className={"h-4 w-4 shrink-0 text-[#8d8d88] transition-transform " + (open ? "rotate-180" : "")} />}
      </button>

      {week ? (
        <div className={"grid transition-[grid-template-rows] duration-300 ease-out " + (open ? "grid-rows-[1fr]" : "grid-rows-[0fr]")}>
          <div className="min-h-0 overflow-hidden">
            <HoursWeekList week={week} />
          </div>
        </div>
      ) : (
        <p className="mt-1.5 text-[13px] leading-6 text-[#55554f] dark:text-[#c5c1b8]">{written}</p>
      )}
    </section>
  );
}